<div class="hmhs-dynamic-form mat-typography mat-body mat-app-background">

  <!-- Form Page Heading -->
  @if (formConfig.pages[currentPage]?.showPageHeader) {
    <h1 class="form-heading">
      {{formConfig.pages[currentPage]?.pageHeader}}
    </h1>
  }

  @if (soaId && !alreadySubmitted && !invalidSoa) {
    <!-- Form Entries Loop -->
    @for (entry of formConfig.pages[currentPage]?.entries; track entry; let i = $index) {
      <div class="form-row"
        [ngClass]="{ 'hide-entry': entry.base?.foreverHidden }">
        <ptl-entry-as-json [entryConfig]="entry" [form]="pageFormGroups" [formConfig]="formConfig">
        </ptl-entry-as-json>
      </div>
    }
    @if (!isOneCheckboxSelected) {
      <div class="page-error">You must select at least one plan checkbox to submit.</div>
    }
    <!-- Form Page Nav BUTTONS -->
    <div class="form-buttons">
      @if (!isLoading) {
        <button mat-raised-button color="primary" class="submit-button" (click)="submitButton()">
          SUBMIT
        </button>
      }
      @if (isLoading) {
        <mat-spinner [diameter]="25"></mat-spinner>
      }
    </div>
  }

  @if (!soaId) {
    <div class="page-error">You must provide an SOA or Referral ID to use this page.</div>
  }

  @if (alreadySubmitted) {
    <div class="page-error">This SOA has already been confirmed.</div>
  }

  @if (invalidSoa) {
    <div class="page-error">The ID provided is invalid.</div>
  }
</div>
